import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Grid,
} from "@mui/material";

const ViewWork = () => {
  const navigate = useNavigate();

  // Example static data — you will replace with API response
  const workData = {
    title: "Wedding Photoshoot – Dubai",
    description:
      "A premium wedding photoshoot completed at Jumeirah Beach – including candid, traditional, and cinematic shots.",
    category: "Photography",
    subCategory: "Wedding",
    dateOfCompletion: "12/11/2025",
    images: [
      "/static/images/placeholder.png",
      "/static/images/placeholder.png",
      "/static/images/placeholder.png",
      "/static/images/placeholder.png",
      "/static/images/placeholder.png",
    ],
  };

  return (
    <>
      {/* PAGE TITLE */}
      <div className="main_title">
        <h1>View Work Details</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/services")}>Services</button> -
          View Work
        </p>
      </div>

      {/* MAIN CARD */}
      <div className="cards view_page">
        <div className="provider-card">
          <Grid container spacing={3}>
            {/* Title of Work */}
            <Grid item xs={12} sm={6}>
              <label className="view_label">Title of Work</label>
              <p className="view_value">{workData.title}</p>
            </Grid>

            {/* Description */}
            <Grid item xs={12} sm={6}>
              <label className="view_label">Description</label>
              <p className="view_value">{workData.description}</p>
            </Grid>

            {/* Category */}
            <Grid item xs={12} sm={6}>
              <label className="view_label">Category</label>
              <p className="view_value">{workData.category}</p>
            </Grid>

            {/* Sub Category */}
            <Grid item xs={12} sm={6}>
              <label className="view_label">Sub-category</label>
              <p className="view_value">{workData.subCategory}</p>
            </Grid>

            {/* Date of Completion */}
            <Grid item xs={12} sm={6}>
              <label className="view_label">Date of Completion</label>
              <p className="view_value">{workData.dateOfCompletion}</p>
            </Grid>

            {/* UPLOAD MEDIA */}
            <Grid item xs={12}>
              <label className="view_label">Uploaded Media</label>

              <div className="media_gallery">
                {workData.images.map((img, index) => (
                  <div key={index} className="media_item">
                    <img src={img} alt={`media-${index}`} />
                  </div>
                ))}
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
};

export default ViewWork;
